import { ValueFormatterParams } from "ag-grid-community";
import { formatNumber } from "../../../utils/format/formatNumber";

export function currencyFormatter(params: ValueFormatterParams): string {
  return formatNumber(params?.value, 2);
}
